import {extendTheme} from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    brand: {
      white: "#f7fafc",
      light: "#f9f9f9",
      black: "#1a202c",
      gray: "#111827",
      gold: "#F59E0B",
      pink: "#FEF2F2",
      ink: "#EF4444",
      orange: "#FFFBEB",
      grey: "rgba(17, 24, 39, 0.5)",
      grey1: "#6B7280",
      lightGreen: "#ECFDF5",
      darkGreen: "#10B981",
    },
  },
  fonts: {
    body: "Poppins, serif"
  },
  fontSizes: {
    10: "0.625rem", //10px
    12: "0.75rem", //12px
    14: "0.875rem", //14px
    16: "1rem", //16px
    18: "1.125rem", // 18px
    20: "1.25rem",
    22: "1.375rem",
    24: "1.5rem", //24px
    32: "2rem", //32px
  },
})